import React, { useContext, useState } from "react";
import { Button, Menu, MenuItem } from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import PartSalesServices from "lib/services/api/commercial/parts";
import { ToastMessageContext } from "lib/contexts/message_context";

// Custom styles for each status
const useStyles = makeStyles({
    button: {
        height: "30px",
        borderRadius: "5px",
        textTransform: "uppercase",
        minWidth: "97px",
        fontSize: "14px",

    },
    green: {
        backgroundColor: "transparent",
        color: "#4CAF50",
        border: "1px solid #4CAF50",
        textDecorationColor: "#4CAF50"

    },
    amber: {
        backgroundColor: "transparent",
        color: "#FFA726",
        border: "1px solid #FFA726",
        textDecorationColor: "#FFA726"
    },
    red: {
        backgroundColor: "transparent",
        color: "#F44336",
        border: "1px solid #F44336",
        textDecorationColor: "#F44336"
    },
    grey: {
        backgroundColor: "transparent",
        color: "#4D4F5C",
        border: "1px solid #4D4F5C",
        textDecorationColor: "#4D4F5C"
    },

});

// Status component
const StatusButton = (props) => {
    const classes = useStyles();
    const { status, type, setAction, setCurrentSelection, rowDetails } = props;
    const isCompleteRed = ["complete"].includes(status) && rowDetails?.number_status === 6
    const isCompleteGreen = ["complete"].includes(status) && rowDetails?.number_status === 3


    // Determine status and style
    const getSubStatusDetails = () => {
        switch (status) {
            case "quote":
                return { label: "QUOTE", style: classes.green };
            case "pending":

                return { label: "PENDING", style: classes.amber };
            case "overdue":
                return { label: "OVERDUE", style: classes.red };

            case "repair":
                return { label: "REPAIR", style: classes.grey };
            case "complete":
                if (isCompleteGreen) {
                    return { label: "COMPLETE", style: classes.green };
                } else {
                    return { label: "COMPLETE", style: classes.red };
                }

            case "rejected":
                return { label: "REJECTED", style: classes.red };
            case "cancelled":
                return { label: "CANCELLED", style: classes.red };

        }
    };

    const { label, style } = getSubStatusDetails()
    // sub tab sttaus action 





    return (
        <>
            <Button variant="outlined" className={`${classes.button} ${style}`} onClick={(e) => {
                if (type === "view") {
                    setAction("view")
                    setCurrentSelection(rowDetails)
                }
            }}>
                {label}
            </Button>

        </>
    );
};

export default StatusButton;
